import { render, staticRenderFns } from "./AssetManager.vue?vue&type=template&id=291bae72&scoped=true&"
import script from "./AssetManager.vue?vue&type=script&lang=ts&"
export * from "./AssetManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291bae72",
  null
  
)

export default component.exports